import React, { useEffect, useState, memo } from 'react';
import {
  AppstoreOutlined,
  BuildOutlined,
  PicRightOutlined,
  SecurityScanOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import { PropTypes } from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import { SiderWrapper } from './styled';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type
  };
}

function Sider(props) {
  const { collapsed, toggleCollapsed } = props;
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    setSelectedKeys(location.pathname);
  });

  const items = [
    getItem(<NavLink to="/">Dashboard</NavLink>, '/', <AppstoreOutlined />),
    getItem('Banner', 'Banner', <BuildOutlined />, [
      getItem(<NavLink to="/banner">Danh sách</NavLink>, '/banner'),
      getItem(<NavLink to="/banner/create">Tạo tập banner</NavLink>, '/banner/create')
    ]),
    getItem('Bài viết', 'sub1', <PicRightOutlined />, [
      getItem(<NavLink to="/categories">Danh mục</NavLink>, '/categories'),
      getItem(<NavLink to="/posts">Bài viết</NavLink>, '/posts'),
      getItem(<NavLink to="/posts/create">Tạo bài viết mới</NavLink>, '/posts/create'),
      getItem(<NavLink to="/posts/draft">Bản nháp</NavLink>, '/posts/draft')
    ]),
    getItem(
      <NavLink to="/risk-management">Quản trị RR</NavLink>,
      '/risk-management',
      <SecurityScanOutlined />
    ),
    getItem(
      <NavLink to="/push-notification">Gửi thông báo</NavLink>,
      '/push-notification',
      <SecurityScanOutlined />
    )
  ];

  return (
    <SiderWrapper
      collapsible={true}
      collapsed={collapsed}
      onCollapse={toggleCollapsed}
      theme="dark">
      <div className="h-16 flex justify-center align-baseline">
        {/* <img className="w-36 h-auto" src="https://takeprofit.vn/logo.svg" alt="logo" /> */}
      </div>
      <Menu selectedKeys={selectedKeys} mode="inline" theme="dark" items={items} />
    </SiderWrapper>
  );
}

Sider.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  toggleCollapsed: PropTypes.func.isRequired
};

export default memo(Sider);
